import { ChevronDownIcon } from '@heroicons/react/20/solid';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { classNames } from '../helpers/functions';
import { ChevronRightIcon, XMarkIcon } from '@heroicons/react/24/outline';

export const SimpleAccordian = ({
	title,
	children,
	showByDefault = false,
	showCount = false,
	count,
	alwaysOpen = false,
	titleClassName,
	className,
}) => {
	const [show, setShow] = useState(showByDefault || alwaysOpen);

	return (
		<div className={classNames('pb-3', className)}>
			<h3
				class={classNames(
					alwaysOpen ? '' : 'cursor-pointer',
					'text-xs font-semibold leading-6 text-gray-700 flex align-center items-center tracking-tight mb-2',
					titleClassName
				)}
				onClick={() => {
					if (!alwaysOpen) {
						setShow(!show);
					}
				}}
			>
				{alwaysOpen ? (
					<div className="ml-6"></div>
				) : (
					<ChevronDownIcon
						className={classNames(
							'w-4 h-4 mr-2',
							'text-gray-400 transition ease-in-out',
							show ? 'rotate-0' : '-rotate-90'
						)}
					/>
				)}

				{`${title} ${showCount ? (count ? `(${count})` : '(0)') : ''}`}
			</h3>

			<div
				className={classNames(
					'ease-in-out transition ml-2',
					show ? 'opacity-100 pb-4 display' : 'opacity-0 hidden'
				)}
			>
				{children}
			</div>
		</div>
	);
};

const AccordianList = ({
	title,
	itemKey,
	total,
	list = [],
	children,
	max = 10,
	filter,
	showByDefault = false,
	showSearch,
	forceHighlight,
	size,
}) => {
	const navigate = useNavigate();

	const [show, setShow] = useState(showByDefault);
	const [search, setSearch] = useState('');

	useEffect(() => {
		if (search) {
			setShow(true);
		}
	}, [search]);

	return (
		<div>
			<h3
				class={classNames(
					size === 'xs' ? 'text-xs' : 'text-sm',
					' cursor-pointer font-semibold leading-6 text-gray-700 flex align-center items-center tracking-tight mb-2'
				)}
				onClick={() => {
					setShow(!show);
					setSearch('');
				}}
			>
				{size === 'xs' ? (
					<ChevronDownIcon
						className={classNames(
							'w-4 h-4 ',
							'text-gray-400 transition ease-in-out',
							show ? 'rotate-0' : '-rotate-90'
						)}
					/>
				) : (
					<div
						className={classNames(
							size === 'xs' ? 'mr-5' : 'mr-3',
							'p-1 flex items-center justify-center'
						)}
					>
						<ChevronDownIcon
							className={classNames(
								'w-4 h-4 text-gray-400 transition ease-in-out',
								show ? 'rotate-0' : '-rotate-90'
							)}
						/>
					</div>
				)}

				{`${title} ${total ? `(${total})` : '(0)'}`}
			</h3>

			{show && (
				<>
					{!filter && showSearch && (
						<div className="text-xxs relative">
							<input
								className="w-full border rounded-lg border-gray-200 px-4 py-2 text-xs mb-3 focus:outline-none"
								placeholder="Search..."
								onChange={(e) => setSearch(e.target?.value)}
								value={search}
								autoFocus
							/>
							{search ? (
								<div
									className="absolute right-1 top-1 p-2 cursor-pointer"
									onClick={() => setSearch('')}
								>
									<XMarkIcon className="w-3 h-3 text-gray-500" />
								</div>
							) : null}
						</div>
					)}

					{children || (
						<ul role="list" className="divide-y divide-gray-100">
							{list
								?.filter((item) =>
									search
										? item?.name
												?.toLowerCase()
												.indexOf(search.toLowerCase()) !== -1
										: true
								)
								.map((item) => (
									<li
										key={item?.label}
										className={classNames(
											'py-2 px-4 cursor-pointer',
											item?.id === filter || forceHighlight
												? 'bg-indigo-50'
												: 'hover:bg-gray-50 '
										)}
										onClick={() => {
											navigate(
												item?.id === filter || forceHighlight
													? '/assets'
													: `/assets/${itemKey}/${item?.id}`
											);
										}}
									>
										<div className="flex items-center gap-x-2">
											<h3 className="flex-auto truncate text-xs leading-6 text-gray-900">
												{item.name}
											</h3>
											{item?.id === filter || forceHighlight ? (
												<XMarkIcon className="w-4 h-4 text-gray-500" />
											) : (
												<ChevronRightIcon className="w-4 h-4 text-gray-500" />
											)}
										</div>
									</li>
								))}
						</ul>
					)}
				</>
			)}
		</div>
	);
};

export default AccordianList;
